<template>
  <pl-dialog title="Duplicate to which course(s)?" size="md_xl" :disableOutsideClick="true" @close="$emit('close')">
    <div class="h-full w-full px-6 pb-6 min-h-1/5 overflow-y-auto overflow-x-hidden">
      <div class="h-full flex flex-col">
        <div id="header-information-course" class="p-6 border-t border-r border-l border-solid border-gray-200 bg-gray-100 rounded-t-md">
          <div class="flex justify-between items-center">
            <div id="select_course_component" class="flex items-center space-x-3">
              <div class="bg-blueGray-700 rounded-full p-2.5">
                <img src="/static/roundtable_options_create/courses_icon.svg" class="h-4 w-4" alt="course_parlay" />
              </div>
              <div>
                <h5 class="text-base text-blueGray-800 font-poppins font-semibold">Select Course</h5>
              </div>
            </div>
            <div id="search_course">
              <div class="flex items-center space-x-2 bg-white border border-solid border-gray-300 rounded-md w-64 px-3 py-1.5 focus-within:border-gray-400">
                <i class="fa-solid fa-magnifying-glass text-gray-400"></i>
                <input
                  placeholder="Search..."
                  v-model="searchCourse"
                  class="w-full bg-white font-poppins font-light text-gray-700 focus-within:border-white border-white"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="overflow-y-auto h-1 flex-grow rounded-b bg-gray-100 border-r border-b border-l border-gray-200 border-solid">
          <ul class="px-6">
            <li
              v-for="(course, index) in coursesFiltered"
              :key="index"
              @click="handleSelectCourse(course)"
              class="flex mb-2 justify-between bg-white px-5 py-3.5 rounded-md hover:border-primary border border-solid border-gray-200 cursor-pointer"
              :class="{'border-primary': isCourseSelected(course.id) === true }"
            >
              <div class="flex items-center space-x-2">
                <h6 class="hover:underline">{{ course.title }}</h6>
                <div class="flex items-center space-x-1.5 text-gray-500 font-light">
                  <span>{{ course.sections[0] }}</span>
                </div>
              </div>
              <Checkbox :is_checked="isCourseSelected(course.id)" />
            </li>
            <div v-if="coursesFiltered.length === 0 && loadingCourses === false" class="flex h-full flex-col items-center">
              No Courses are found
            </div>
            <div v-if="loadingCourses === true" class="h-full flex flex-col justify-center items-center">
              <div class="flex justify-center items-center mb-2">
                <pl-spinner></pl-spinner>
              </div>
              <div class="text-center">Loading Courses</div>
            </div>
          </ul>
        </div>
        <div class="bg-white mt-5">
          <div class="flex items-center justify-start space-x-2 mb-5">
            <Checkbox :is_checked="isToCopyCriteria" @input="(value) => isToCopyCriteria = value" />
            <span class="font-poppins font-light text-gray-800">Also copy assessment criteria to new course</span>
          </div>
          <div class="flex justify-between items-center">
            <div class="flex items-center space-x-1">
              <button
                @click="$emit('close')"
                class="px-5 bg-white border border-solid border-gray-200 py-2 hover:bg-gray-100 rounded cursor-pointer text-gray-800 :hover:text-gray-900 font-medium disabled:opacity-50"
              >
                Cancel
              </button>
              <Tooltip :text="getProfile.activity_passes +' RoundTables left. Click to upgrade account.'" positionTooltip="relative">
                <button
                  @click="handleClickUpgradeAccount()"
                  v-if="!getProfile.is_paid"
                  class="inline-flex hover:text-gray-900 items-center justify-center border border-solid border-coolGray-200 w-10 h-10 text-gray-700 transition-colors duration-150 bg-coolGray-50 rounded focus:shadow-outline hover:bg-coolGray-100"
                >
                  <i class="fas fa-rocket text-base text-pinky"></i>
                </button>
              </Tooltip>
            </div>
            <div class="flex">
              <button
                class="cursor-pointer mr-4"
                v-if="isInformationVisible === false"
                @click="handleOpenInformation()"
              >
                <i class="fa-solid fa-circle-info text-blueGray-700 hover:text-blueGray-800 text-base"></i>
              </button>
              <button
                :disabled="selectedCourses.length === 0"
                @click="handleDuplicateRoundTable()"
                class="flex bg-primary rounded font-medium px-4 py-2 hover:bg-primary-dark text-white disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Duplicate ({{ selectedCourses.length }})
                <div class="loader" v-if="isLoading === true"></div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </pl-dialog>
</template>

<script>
  import Vue from 'vue';
  import get from 'lodash/get';
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';

  export default Vue.extend({
    components: {
      Tooltip: () => import('../../../components/Tooltip.vue'),
      Checkbox: () => import('../New_RoundTable/Components/Checkbox.vue'),
    },
    props: {
      is_live_roundtable: {
        type: Boolean,
        default() {
          return false;
        },
      },
      rt_selected: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        selectedCourses: [],
        selected_index: null,
        loadingCourses: false,
        isInformationVisible: true,
        searchCourse: '',
        isLoading: false,
        teacherCourses: [],
        isToCopyCriteria: true
      };
    },
    computed: {
      ...mapGetters([
        'getCourses',
        'getCurrentRT',
        'getCurrentDiscussion',
        'getProfile',
      ]),
      courses_I_teach() {
        return this.teacherCourses.filter((course) => {
          if (course.is_sample !== true && !course.is_archived) {
            const role = get(course, 'users[0].subscription.role');
            return ['author', 'co-teacher'].includes(role);
          }
        });
      },
      coursesFiltered() {
        let filtered;
        if (this.selectedOption === this.searchCourse)
          return this.courses_I_teach;
        if (!this.searchCourse) return this.courses_I_teach;
        filtered = this.courses_I_teach.filter((course) => {
          if (!course.is_archived) {
            if (
              course.title ||
              course.id !== this.$store.state.course_sample_id
            )
              return (
                course.title
                  .toLowerCase()
                  .indexOf(this.searchCourse.toLowerCase()) != -1
              );
          }
        });
        return filtered;
      },
    },
    methods: {
      handleCloseInformation: function () {
        this.isInformationVisible = false;
      },
      handleScrollCourses: function () {
        if (this.isInformationVisible === true) {
          return setTimeout(() => this.handleCloseInformation(), 30);
        }
      },
      handleOpenInformation: function () {
        this.$refs.containerCourses.scrollTop = 0;
        setTimeout(() => {
          this.isInformationVisible = true;
        }, 410);
      },
      handleScrollSearchBar: function () {
        this.$refs.containerCourses.scrollTop = 0;
        this.$refs['searchInput'].focus();
      },
      handleSelectCourse: function (clickedCourse) {
        const is_course_exist = this.selectedCourses.find(
          (item) => item.id === clickedCourse.id
        );
        if (is_course_exist === undefined) {
          this.selectedCourses.push(clickedCourse);
          return;
        }
        const index = this.selectedCourses.findIndex(
          (course) => course.id === clickedCourse.id
        );
        this.selectedCourses.splice(index, 1);
      },
      handleDuplicateRoundTable: async function () {
        if (this.isLoading) return;
        if (!this.getProfile.is_paid && this.getProfile.activity_passes === 0) {
          const toast = { type: 'Error', message: 'Sorry! You need to upgrade account...', time: 5000 };
          return EventBus.$emit('createToast', toast);
        }
        if (!this.getProfile.is_paid && this.selectedCourses.length > this.getProfile.activity_passes) {
          const toast = { type: 'Error', message: `You have (${this.getProfile.activity_passes}) free RoundTables remaining.`, time: 5000 };
          EventBus.$emit('createToast', toast);
          return;
        }
        this.isLoading = true;
        const courses = this.selectedCourses.map((x) => x.id);
        if (!this.is_live_roundtable) {
          const duplicate_RT_id = this.rt_selected && this.rt_selected.id ? this.rt_selected.id : this.getCurrentRT.id;
          const duplicated_RTs = await this.$store.dispatch('duplicateOnlineRoundtable', { duplicate_RT_id, courses, isToCopy: this.isToCopyCriteria });
          if (duplicated_RTs) {
            if (this.rt_selected && this.rt_selected.id) {
              EventBus.$emit('duplicate_rt');
            }
            const toast = { 
              type: 'Success', 
              message: courses.length === 1 ? `RoundTable successfully duplicated to ${this.selectedCourses[0].title}` : 'RoundTables successfully duplicated', 
              time: 5000,
              link: courses.length === 1 ? { roundtable_id: duplicated_RTs[0].id, course_id: this.selectedCourses[0].id } : {},
            };
            EventBus.$emit('createToast', toast);
          }
          this.isLoading = false;
          this.$emit('close');
          return;
        }

        const duplicate_id = this.rt_selected && this.rt_selected.id  ? this.rt_selected.id : this.getCurrentDiscussion.id;
        this.selectedCourses.forEach(async (course) => {
          const course_id = course.id;
          const duplicated_LD = await this.$store.dispatch('duplicateLiveDiscussion', { duplicate_id, course_id, isToCopy: this.isToCopyCriteria });
          if (duplicated_LD) {
            if (this.rt_selected && this.rt_selected.id) {
              EventBus.$emit('duplicate_rt');
            }
            const toast = {
              type: 'Success',
              message: this.selectedCourses.length === 1 ? `RoundTable successfully duplicated to ${course.title}` : 'RoundTables successfully duplicated',
              time: 5000,
              link: this.selectedCourses.length === 1 ? { live_discussion_id: duplicated_LD.id, course_id: course_id } : {},
            };
            EventBus.$emit('createToast', toast);
          }
          this.$emit('close');
        });
        return;
      },
      handleClickUpgradeAccount: function () {
        this.$router.push({ name: 'profile.membership' });
      },
      isCourseSelected: function (course_id) {
        const is_course_exist = this.selectedCourses.find(
          (item) => item.id === course_id
        );
        return is_course_exist !== undefined ? true : false;
      },
    },
    mounted: async function () {
      this.loadingCourses = true;
      const courses = await this.$store.dispatch('setCourseList', 'teacher');
      if (courses) {
        this.loadingCourses = false;
        this.teacherCourses = courses;
      }
    },
  });
</script>
<style scoped>
  input[type='checkbox'] {
    margin-top: 4px;
    width: 1.25rem !important;
    height: 1.25rem !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
    box-shadow: none;
    border-color: #d7d7d7;
    font-size: 0.8rem;
    text-align: center;
    line-height: 1.25rem;
    border-radius: 0.25rem;
    background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
  }
  input[type='checkbox']:checked {
    background-color: #72ccd7;
    margin-bottom: 5px;
    margin-top: 4px;
    border-color: #72ccd7;
  }
  input[type='checkbox']:checked::after {
    font-family: 'Font Awesome 5 Free';
    content: '\f00c';
    font-weight: 900;
    color: white;
    line-height: 1.25rem;
  }
  .loader,
  .loader:after {
    border-radius: 50%;
    width: 20px;
    height: 20px;
    margin-left: 12px;
    margin-top: 1px;
  }
  .loader {
    border-top: 3px solid rgba(255, 255, 255, 0.2);
    border-right: 3px solid rgba(255, 255, 255, 0.2);
    border-bottom: 3px solid rgba(255, 255, 255, 0.2);
    border-left: 3px solid #ffffff;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation: load8 1.1s infinite linear;
    animation: load8 1.1s infinite linear;
  }
  @-webkit-keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// duplicateRoundtableModal.vue?6f1b0618